/* eslint-disable @typescript-eslint/prefer-namespace-keyword */
/* eslint-disable @typescript-eslint/no-namespace */

export module Actions {
  export class Ltos {
    public static GetAll = "LtosGetAll";
    public static GetBookingStatistics = "LtosGetBookingStatistics";
    public static GetAllEmployees = "LtosGetAllEmployees";
    public static GetLtoById = "LtosGetById";
    public static GetLtoTermsById = "LtosGetTermsById";
    public static CreateLto = "LtosCreateLto";
    public static UpdateLtoProfile = "LtosUpdateLtoProfile";
    public static UpdateLtoEmployee = "LtosUpdateLtoEmployee";
    public static AddLtoEmployee = "LtosAddLtoEmployee";
    public static UpdateLtoSettings = "LtosUpdateLtoSettings";
    public static enableLto = "LtosEnableLto";
    public static disableLto = "LtosDisableLto";
    public static GetAdminStats = "LtosAdminStats";
    public static ClearCurrentLto = "LtosClearCurrent";
  }

  export class Locations {
    public static GetAllRegions = "LocationsGetAllRegions";
    public static GetAllCountries = "LocationsGetAllCountries";
    public static GetCountriesByRegionSlug = "LocationsGetCountriesByRegionSlug";
    public static GetDestinationsByCountrySlug = "LocationsGetDestinationsByCountrySlug";
    public static GetLocationBySlug = "LocationsGetLocationBySlug";
    public static SetDefaultLto = "LocationsSetDefaultLto";
    public static CreateLocation = "LocationsCreateLocation";
    public static UpdateLocation = "LocationsUpdateLocation";
    public static UpdateLocationWeather = "LocationsUpdateLocationWeather";
    public static UpdateLocationStatus = "LocationsUpdateStatus";
    public static UpdateLocationImageDescription = "LocationsImageDescription";
  }

  export const LtoLocation = {
    /**
     * Also used for setting - we don't need to do anything client side other than refresh data in the store
     */
    GetConfig: "GetLtoLocationConfig",
    SetConfig: "SetLtoLocationCOnfig",
  };

  export class Themes {
    public static GetThemePage = "GetThemePage";
    public static GetThemeForEdit = "GetThemeForEdit";
    public static ClearThemeEditor = "ClearThemeEditor";
    public static SaveThemeFromEditor = "SaveThemeFromEditor";
  }

  export const Enquiries = {
    GetEnquiriesPage: "GetEnquiriesPage",
    GetTriagedEnquiries: "GetTriagedEnquiries",
    GetEnquirySingle: "EnquiriesGetById",
    UpdateEnquiry: "EnquiriesUpdate",
    GetEnquiryMessages: "EnquiriesGetMessages",
    GetEnquiriesForCustomer: "EnquiriesGetForCustomer",
    ToggleEnquiryStatus: "EnquiriesToggleStatus",
    ToggleAdminFollow: "EnquiriesToggleAdminFollow",
    ConfirmEnquiryCancellation: "EnquiriesConfirmCancellation",
    UnrequestEnquiryCancellation: "EnquiriesUnrequestCancellation",
    GetPaymentsForEnquiry: "GetPaymentsForEnquiry",
    AddNewTravelerDetails: "EnquiriesAddNewTravelerDetails",
    UpdateTravelerDetails: "EnquiriesUpdateTravelerDetails",
    UpdateLeadTravelerDetails: "EnquiriesUpdateLeadTravelerDetails",
    DeleteTravelerDetails: "EnquiriesDeleteTravelerDetails",

    Admin: {
      Stats: "AdminEnquiryStats",
    },

    Lto: {
      Stats: "LtoEnquiryStats",
      Focus: "LtoFocusEnquiries",
      Planning: "LtoPlanningEnquiries",
      Unconfirmed: "LtoUnconfirmedEnquiries",
      Confirmed: "LtoConfirmedEnquiries",
      InProgress: "LtoInProgressEnquiries",
      Complete: "LtoCompleteEnquiries",
      Dormant: "LtoDormantEnquiries",
      All: "LtoAllEnquiries",
    },
  };

  export class Content {
    public static GetContentPage = "GetContentPage";
    public static GetContentForEdit = "GetContentForEdit";
    public static SaveContentFromEditor = "SaveContentFromEditor";
  }

  export class Permissions {
    public static GetUserGlobalPermissions = "GetUserGlobalPermissions";
  }
  export class Itineraries {
    public static DeleteAccommodation = "DeleteAccommodation";
    public static DeleteEvent = "DeleteEvent";
    public static UpdateExcursion = "UpdateExcursion";
    public static UpdateTransfer = "UpdateTransfer";
    public static CreateNewExcursion = "CreateNewExcursion";
    public static CreateNewTransfer = "CreateNewTransfer";
    public static CreateNewAccommodation = "CreateNewAccommodation";
    public static AddEventToItineraryDay = "AddEventToItineraryDay";
    public static SetAccommodationForItineraryDay = "SetAccommodationForItineraryDay";
    public static UpdateAccommodationForItineraryDay = "UpdateAccommodationForItineraryDay";
    public static UpdateAccommodation = "UpdateAccommodation";
    public static DeleteAccommodationForItineraryDay = "DeleteAccommodationForItineraryDay";
    public static SetAccommodationTypeForItineraryDay = "SetAccommodationTypeForItineraryDay";
    public static CreateNewItineraryDay = "CreateNewItineraryDay";
    public static DeleteItineraryDay = "DeleteItineraryDay";
    public static MoveItineraryDay = "MoveItineraryDay";
    public static UpdateEventForItineraryDay = "UpdateEventForItineraryDay";
    public static DeleteEventForItineraryDay = "DeleteEventForItineraryDay";
    public static ReorderItineraryDayEvents = "ReorderItineraryDayEvents";
    public static GetItineraryDayById = "GetItineraryDayById";
    public static GetItinerariesForEnquiry = "GetItinerariesForEnquiry";
    public static DeleteEnquiryItinerary = "DeleteEnquiryItinerary";
    public static GetExcursionsPage = "GetExcursionsPage";
    public static GetTransfersPage = "GetTransfersPage";
    public static GetAccommodation = "AccommodationsGetAccommodation";
    public static GetAccommodationPage = "GetAccommodationPage";
    public static GetItinerariesPage = "GetItinerariesPage";
  }

  export class EnquiryItineraries {
    public static CreateNew = "EnquiryItineraryCreateNew";
    public static GetItineraryById = "EnquiryItineraryGetById";
    public static GetDraftItineraryById = "EnquiryItineraryGetDraftById";
    public static GetLiveItineraryById = "EnquiryItineraryGetLiveById";
    public static GetLiveItineraryQuoteById = "EnquiryItineraryGetLiveQuoteById";
    public static GetCurrenciesForQuote = "GetCurrenciesForQuote";
    public static UpdateEnquiryItinerary = "EnquiryItineraryUpdate";
    public static AddLineItem = "EnquiryItineraryAddLineItem";
    public static UpdateLineItem = "EnquiryItineraryUpdateLineItem";
    public static RemoveLineItem = "EnquiryItineraryRemoveLineItem";
    public static UpdatePricingInformation = "EnquiryItineraryUpdatePricingInformation";
    public static ClearCurrentItinerary = "EnquiryItineraryClearCurrent";
  }

  export class SampleItineraries {
    public static CreateSampleItinerary = "SampleItineraryCreate";
    public static GetSampleItinerariesByLtoId = "SampleItinerariesGetByLtoId";
    public static GetSampleItineraryBySlug = "SampleItinerariesGetBySlug";
    public static UpdateSampleItinerary = "SampleItineraryUpdate";
    public static DeleteSampleItinerary = "SampleItineraryDelete";
    public static UpdateSampleItineraryStatus = "SampleItineraryUpdateStatus";
  }

  export class General {
    public static GetProfile = "GeneralGetProfile";
    public static GetAllCurrencies = "GeneralGetAllCurrencies";
    public static UpdateExchangeRates = "GeneralUpdateExchangeRates";
    public static CreateNonDigitalPayment = "CreateNonDigitalPayment";
    public static CreateRefund = "CreateRefund";
    public static GetAllCardTypes = "GeneralGetAllCardTypes";
    public static GetPaymentsPage = "GeneralGetPaymentsPage";
    public static UpdateDigitalPayment = "GeneralUpdateDigitalPayment";
  }

  export class Reviews {
    public static GetReview = "ReviewsGetReview";
    public static GetAllReviews = "ReviewsGetAllReviews";
    public static GetReviewPage = "ReviewsGetReviewPage";
    public static GetReviewsByLtoId = "ReviewsGetByLtoId";
    public static UpdateReview = "ReviewsUpdateReview";
    public static PublishReview = "ReviewsPublishReview";
    public static CreateReview = "ReviewsCreateReview";
    public static DeleteReview = "ReviewsDeleteReview";
    public static ReplyToReview = "ReviewsReplyToReview";
    public static ResetPages = "ReviewsResetPages";
  }

  export class Images {
    public static DeleteImage = "DeleteImage";
  }

  export const Users = {
    UpdateUserProfile: "UsersUpdateUserProfile",
    GetUserProfile: "UsersGetUserProfile",
    GetAll: "GetAllUsers",
  };

  export class Snippets {
    public static GetSnippetsPage = "GetSnippetsPage";
    public static UpdateSnippet = "UpdateSnippet";
    public static CreateSnippet = "CreateSnippet";
    public static GetSnippetById = "GetSnippetById";
  }

  export class Settings {
    public static GetSettings = "GetSettings";
    public static UpdateSettings = "UpdateSettings";
  }
}
